import { useInfiniteQuery } from '@tanstack/react-query';
import { subscriptionApi } from '~/lib/request';
import { TransactionResponse } from './types';

const LIMIT = 10;

function useAllTransactions() {
  const query = useInfiniteQuery({
    queryKey: ['allTransactions', LIMIT],
    queryFn: ({ pageParam = 0 }) =>
      subscriptionApi
        .get('api/transactions/transactions', {
          searchParams: {
            skip: pageParam.toString(),
            limit: LIMIT.toString(),
          },
        })
        .json<TransactionResponse>(),
    getNextPageParam: (lastPage, allPages) => {
      const nextSkip = allPages.length * LIMIT;
      return nextSkip < (lastPage?.total ?? 0) ? nextSkip : undefined;
    },
    getPreviousPageParam: (_firstPage, allPages) => {
      const prevSkip = (allPages.length - 2) * LIMIT;
      return prevSkip >= 0 ? prevSkip : undefined;
    },
    initialPageParam: 0,
    throwOnError: true,
  });

  const transactions = query.data?.pages.flatMap((page) => page.data) ?? [];
  const total = query.data?.pages[0]?.total || 0;
  const totalPages = Math.ceil(total / LIMIT);
  const currentPage = query.data?.pageParams.length ?? 1;

  return {
    ...query,
    transactions,
    total,
    totalPages,
    currentPage,
  };
}

export default useAllTransactions;
